import { getErrorMessage } from "@/utils/getErrorMessage";
import { toast, toaster } from "./toaster";

export const notify = {
  success: (title: string, description?: string) =>
    toast({ title, description, status: "success", duration: 3000 }),

  info: (title: string, description?: string) =>
    toast({ title, description, status: "info", duration: 4000 }),

  warning: (title: string, description?: string) =>
    toast({ title, description, status: "warning", duration: 5000 }),

  error: (
    title: string,
    error?: unknown,
    fallback = "Inténtalo de nuevo. Si persiste, avisa al administrador.",
  ) =>
    toast({
      title,
      description:
        error !== undefined ? getErrorMessage(error, fallback) : fallback,
      status: "error",
      duration: 6000,
    }),

  run: async (
    action: () => Promise<unknown>,
    messages: { loading: string; success?: string; error: string },
  ) => {
    const id = toaster.create({ title: messages.loading, type: "loading" });
    try {
      await action();
      if (messages.success) {
        toaster.update(id, {
          title: messages.success,
          type: "success",
          duration: 3000,
        });
      } else {
        toaster.dismiss(id);
      }
    } catch (error) {
      toaster.update(id, {
        title: messages.error,
        description: getErrorMessage(
          error,
          "Inténtalo de nuevo. Si persiste, avisa al administrador.",
        ),
        type: "error",
        duration: 6000,
      });
    }
  },
};
